// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__xysbV","userContainer":"Menu_userContainer__mCWjL","butCont":"Menu_butCont__cyh+J","img":"Menu_img__4aU3l","delete":"Menu_delete__p4v3Y"};